import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

interface IProps {
  size?: number
  thickness?: number
  color?: 'inherit' | 'primary' | 'secondary'
  minHeight?: string
  width?: string
}

const Preloader: React.FC<IProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: props.minHeight ? props.minHeight : '150px',
      width: props.width ? props.width : '100%',
    },
  }))

  const classes = useStyles()
  return (
    <div className={classes.root}>
      <CircularProgress size={props.size} color={props.color} thickness={props.thickness} />
    </div>
  )
}

export default Preloader
